import { Component, Vue, Inject, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import store from "@/store";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_MESSAGES,
  LIST_DATA_EVENTS,
  LOCAL_STORAGE
} from "@/shared/constants/FormConstants";
import { Utils } from "@/shared/utils/utils";
import {
  GENERAL_CONSTANTS,
  KEYTYPE_CONSTANTS,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { NavigationGuardNext, Route } from "vue-router";
import {
  ACTIONS,
  CHART_DATA_RENDER,
  MULTIMEDIA_ACCESS,
  MULTIMEDIA_CONSTANTS,
  MULTIMEDIA_FILTERS,
  NEW_FILE
} from "./constants/multimediaConstants";
import { SearchContext } from "@/shared/models/SearchContext";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { Http } from "@status/codes";
import { MultimediaQuery } from "./models/MultimediaQuery.model";
import { Response } from "@/shared/models/Response";
import { MultimediaService } from "./services/MultimediaService";
import { MultimediaDTO } from "./models/Multimedia.model";
import SaveFile from "./components/saveFile/SaveFile.vue";
import { MulimediaResponse } from "./models/MultimediaResponse";
import { CrudChartData } from "@/shared/models/CrudChartData";
import { CrudChartRenderData } from "../Dashboards/AdminDashboard/models/CrudChartRenderData";
import { CHART_INIT } from "@/shared/components/CrudChart/constants/CrudChartConstants";
import { ListService } from "../List/services/ListService";
import { List } from "@/shared/components/GenericSearchBar/model/List";
import { LACK_OF_OPTIONS } from "../Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { ChartRenderData } from "../Dashboards/AdminDashboard/models/ChartRenderData";
import CrudChart from "@/shared/components/CrudChart/CrudChart.vue";
import DocumentViewer from "@/shared/components/DocumentViewer/DocumentViewer.vue";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { AxiosError } from "axios";
import { LIST_ACCESS } from "../List/constants/ListConstants";

Component.registerHooks(["beforeRouteLeave"]);
@Component({
  name: "Multimedia",
  components: { EmptyState, SaveFile, CrudChart, DocumentViewer },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView",
      dataToLateralMenu: "getDataToLateralMenu"
    })
  }
})
export default class Multimedia extends Vue {
  @Inject() multimediaService!: MultimediaService;
  @Inject() listService!: ListService;

  dataToMainView!: MenuDataStructure;
  dataToLateralMenu!: MenuDataStructure;

  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  OPERATIONS: string[] = [LIST_DATA_EVENTS.VIEW_DATA];
  admin = false;
  filterArray = MULTIMEDIA_FILTERS.MAIN;
  CLICK_ACTION = LIST_DATA_EVENTS.EDIT_DATA;
  changeItem = false;
  filesList: Array<MultimediaDTO> = [];
  loadingData = false;
  filterQuery: MultimediaQuery = {};
  canSearch = true;
  showCharts = false;
  dataTypeToChart?: CrudChartRenderData = CHART_INIT;
  dataCategoryToChart?: CrudChartRenderData = CHART_INIT;
  chartDataType: ChartRenderData = { ...CHART_DATA_RENDER };
  chartDataCategory: ChartRenderData = { ...CHART_DATA_RENDER };
  isVisibleSaveMultimedia = false;
  chartSelectedFilter: string[] = [];
  tooltipAddButton: string = ACTIONS.ADD_FILE;
  currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
  MULTIMEDIA_CONSTANTS = MULTIMEDIA_CONSTANTS;
  EMPTY_STATE = FORM_MESSAGES.INFO_MESSAGE;
  action = MULTIMEDIA_CONSTANTS.CREATE_ACTION;
  fileToEdit: MultimediaDTO = { ...NEW_FILE };
  PAGE_TITLE: string = MULTIMEDIA_CONSTANTS.PAGE_TITLE;
  cardClass = STYLE_CLASSES.CARD;
  categories: List[] = [];
  newFile = false;
  multimediaPath = "";
  showModaViewFile = false;
  fileName = "";

  mounted() {
    const views = localStorage.getItem(LOCAL_STORAGE.VIEWS);
    if (
      (JSON.parse(views as string) as string[]).includes(
        LOCAL_STORAGE.ADMIN_ROLE
      )
    ) {
      this.admin = true;
    }
    this.OPERATIONS = Utils.addExtraOperations(
      this.OPERATIONS,
      COLLECTIONS_NAME.MULTIMEDIA
    );
    this.searchFiles(true);
    this.emitSearchInitializer();
  }

  async emitSearchInitializer() {
    await this.getCategoryListMultimedia();
    this.initializeFilters();
    const searchContext: SearchContext = {
      title: MULTIMEDIA_CONSTANTS.PAGE_TITLE_SEARCH,
      filterArray: [this.filterArray],
      operations: this.OPERATIONS,
      clickAction: this.CLICK_ACTION,
      callbackHandleOperation: this.handleOperation,
      componentName: COMPONENT_NAME_MODAL.MULTIMEDIA,
      descriptions: [MULTIMEDIA_CONSTANTS.TYPE, MULTIMEDIA_CONSTANTS.CATEGORY],
      textButtonCreate: ACTIONS.ADD_FILE
    };
    const data = {
      ...searchContext
    };
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      data
    );
  }

  initializeFilters() {
    this.filterArray.secondaryFilters = [];
    this.filterArray.secondaryFilters.push(MULTIMEDIA_FILTERS.SECONDARY.NAME);
    this.filterArray.secondaryFilters.push(MULTIMEDIA_FILTERS.SECONDARY.TYPE);
    this.filterArray.secondaryFilters.push(
      MULTIMEDIA_FILTERS.SECONDARY.CATEGORY
    );
    this.filterArray.secondaryFilters.push(MULTIMEDIA_FILTERS.SECONDARY.STATE);
  }

  handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.changeItemConfirmation(itemId);
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        this.deleteFile(itemId);
        this.actionCancel();
        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.updateStateFileById(itemId, STATE.ACTIVE);
        this.actionCancel();
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.updateStateFileById(itemId, STATE.INACTIVE);
        this.actionCancel();
        break;
      case LIST_DATA_EVENTS.CANCEL_DATA:
        this.actionCancel();
        break;
      case LIST_DATA_EVENTS.VIEW_DATA:
        this.viewFile(itemId);
        break;
    }
  }

  viewFile(itemId: string) {
    const findFile = this.filesList.find(
      (file: MultimediaDTO) => file._key === itemId
    );

    if (findFile) {
      this.multimediaPath = findFile.multimediaPath;
      this.fileName = findFile.fieldName;
      this.showModaViewFile = true;
    }
  }

  closePreview() {
    this.showModaViewFile = false;
    this.multimediaPath = "";
    this.fileName = "";
  }

  @Watch("dataToMainView")
  handleDataToMainView() {
    const validations: Record<string, void> = {
      Panel: this.panelValidation()
    };
    validations[this.dataToMainView.from];
  }

  panelValidation() {
    if (this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH) {
      switch (this.dataToMainView.action) {
        case PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE:
          this.searchFiles(true, this.dataToMainView.data, true);
          break;
        case PANEL_INFO_CONSTANTS.ACTION.SHOW_CRUD_SAVE:
          this.actionButtonAdd(this.action);
          break;
        case PANEL_INFO_CONSTANTS.ACTION.DO_ON_BOTTOM_CONTEXT:
          this.sendDataToLateralMenu(
            PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT
          );
          break;
      }
    }
  }

  changeItemConfirmation(fileId: string) {
    this.changeItem = true;
    this.editFile(fileId);
  }

  async deleteFile(fileId: string) {
    try {
      const responseData = await this.multimediaService.deleteFile(fileId);
      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        if (fileId === this.fileToEdit._key) {
          this.isVisibleSaveMultimedia = false;
        }
        this.deleteFileOfTheList(fileId);
      } else if (responseData.code === Http.Found) {
        Snackbar.popWarning(MULTIMEDIA_CONSTANTS.MULTIMEDIA_USED);
      } else {
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + MULTIMEDIA_ACCESS.DELETE
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  deleteFileOfTheList(fileId: string) {
    this.filesList = this.filesList.filter((item: MultimediaDTO) => {
      return item._key !== fileId;
    });
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
      this.filesList
    );

    this.tooltipAddButton = ACTIONS.ADD_FILE;
    this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
    this.action = MULTIMEDIA_CONSTANTS.CREATE_ACTION;
  }

  async updateStateFileById(id: string, state: string) {
    try {
      const responseData = await this.multimediaService.updateStateFileById(
        id,
        state
      );
      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        this.searchFiles(true, {}, true);
      } else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + MULTIMEDIA_ACCESS.PUT
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  actionCancel() {
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
      ""
    );
    this.newFile = !this.newFile;
    this.PAGE_TITLE = MULTIMEDIA_CONSTANTS.PAGE_TITLE;
    this.fileToEdit = { ...NEW_FILE };
    this.isVisibleSaveMultimedia = false;
    this.tooltipAddButton = ACTIONS.ADD_FILE;
    this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
    this.action = MULTIMEDIA_CONSTANTS.CREATE_ACTION;
    this.multimediaPath = "";
  }

  editFile(fileId: string) {
    const findFile = this.filesList.find(
      (file: MultimediaDTO) => file._key === fileId
    );
    if (findFile !== undefined) {
      this.fileToEdit = { ...findFile };
      this.isVisibleSaveMultimedia = true;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
        fileId
      );

      this.PAGE_TITLE = MULTIMEDIA_CONSTANTS.PAGE_TITLE_EDIT;
      this.tooltipAddButton = ACTIONS.CANCEL;
      this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
      this.action = MULTIMEDIA_CONSTANTS.CANCEL_ACTION;
    }
  }

  clickDataType(event: string) {
    this.searchFiles(true, { type: [event.toLocaleLowerCase()] }, false);
  }

  clickDataCategory(event: string) {
    this.searchFiles(true, { category: [event] }, false);
  }

  clickOut() {
    this.searchFiles(true, {}, true);
  }

  async searchFiles(
    shouldSearch: boolean,
    querySearch?: MultimediaQuery,
    newFilter?: boolean
  ) {
    if (!shouldSearch) return;
    this.loadingData = true;
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.LOADING_CONTEXT_AND_HIDE_CARDS
    );

    this.filesList = [];
    this.canSearch = false;
    const filesResponse = await this.getData(newFilter, querySearch);

    if (filesResponse.code === Http.Found && filesResponse.data !== undefined) {
      this.filesList = filesResponse.data.multimediaList;
      this.getDataChart(filesResponse.data?.multimediaChart);
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
        this.filesList
      );
      this.canSearch = true;
      this.showCharts = true;
    } else {
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
      if (filesResponse.code === Http.NotFound) {
        Snackbar.popInfo(filesResponse.message);
      } else {
        Snackbar.popError(filesResponse.message);
      }
      this.showCharts = false;
    }

    this.loadingData = false;
  }

  getDataChart(dataChart: CrudChartData | undefined) {
    if (dataChart) {
      this.chartDataType = Utils.mapChartData(
        dataChart,
        MULTIMEDIA_CONSTANTS.TYPE
      );

      this.dataTypeToChart = {
        chartTitle: MULTIMEDIA_CONSTANTS.FILE_TYPE,
        chartRenderData: this.capitalLetterLabels(this.chartDataType)
      };

      this.chartDataCategory = Utils.mapChartData(
        dataChart,
        MULTIMEDIA_CONSTANTS.CATEGORY
      );
      this.dataCategoryToChart = {
        chartTitle: MULTIMEDIA_CONSTANTS.FILE_CATEGORY,
        chartRenderData: this.chartDataCategory
      };
    } else {
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
    }
  }

  capitalLetterLabels(chartRenderData: ChartRenderData) {
    chartRenderData.labels = [...chartRenderData.labels].map(item => {
      return item.charAt(0).toUpperCase() + item.slice(1);
    });

    return chartRenderData;
  }

  actionButtonAdd(action: string) {
    switch (action) {
      case MULTIMEDIA_CONSTANTS.CREATE_ACTION:
        this.createFile();
        break;
      case MULTIMEDIA_CONSTANTS.CANCEL_ACTION:
        this.cancelSaveFile();
        break;
    }
  }

  createFile() {
    this.PAGE_TITLE = MULTIMEDIA_CONSTANTS.PAGE_TITLE;
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL
    );
    this.newFile = !this.newFile;
    this.fileToEdit = { ...NEW_FILE };
    this.isVisibleSaveMultimedia = true;
    this.tooltipAddButton = ACTIONS.CANCEL;
    this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
    this.action = MULTIMEDIA_CONSTANTS.CANCEL_ACTION;
  }

  cancelSaveFile() {
    this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL);
  }

  sendDataToLateralMenu(action: string, data?: any) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.DISABLE_SEARCH_CONTEXT
    );
    next();
  }

  savedFile() {
    this.searchFiles(true, {}, true);
    this.actionCancel();
  }

  async getData(
    newFilter?: boolean,
    querySearch?: MultimediaQuery
  ): Promise<Response<MulimediaResponse>> {
    try {
      this.processFilter(newFilter, querySearch);
      const response: Response<MulimediaResponse> = await this.multimediaService.getFilesByFilters(
        { ...this.filterQuery, getChartInfo: true, paginateResult: false }
      );
      return response;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden) {
        const RESPONSE_ERROR: Response<MulimediaResponse> = {
          code: Http.Forbidden,
          message: FORM_MESSAGES.FORBIDDEN_REQUEST + MULTIMEDIA_ACCESS.GET,
          data: {
            multimediaList: [],
            multimediaChart: { type: {}, category: {} },
            lastReference: ""
          }
        };

        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + MULTIMEDIA_ACCESS.PUT
        );
        return RESPONSE_ERROR;
      } else {
        const RESPONSE_ERROR: Response<MulimediaResponse> = {
          code: Http.BadRequest,
          message: FORM_MESSAGES.REQUEST_FAILED,
          data: {
            multimediaList: [],
            multimediaChart: { type: {}, category: {} },
            lastReference: ""
          }
        };
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);

        return RESPONSE_ERROR;
      }
    }
  }

  processFilter(newFilter?: boolean, querySearch?: MultimediaQuery) {
    if (newFilter) this.filterQuery = {};
    if (typeof querySearch !== KEYTYPE_CONSTANTS.UNDEFINED) {
      if (querySearch?.name) this.filterQuery.name = querySearch.name;
    }
    if (querySearch?.category) {
      this.filterQuery.category = querySearch.category;
    }
    if (querySearch?.name) {
      this.filterQuery.name = querySearch.name;
    }
    if (querySearch?.state) {
      this.filterQuery.state = querySearch.state;
    }
    if (querySearch?.type) {
      this.filterQuery.type = querySearch.type;
    }
  }

  async getCategoryListMultimedia() {
    const responseData = await this.getListDataById(
      MULTIMEDIA_CONSTANTS.CATEGORY_MULTIMEDIA_ID
    );
    this.categories = responseData !== undefined ? responseData : [];
    MULTIMEDIA_FILTERS.SECONDARY.CATEGORY.options = this.categories as any;
  }

  async getListDataById(id: string) {
    try {
      const responseData = await this.listService.getListById(id);
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const listDataList: List[] = [];
        const dataList = responseData.data.optionsSchema as {
          title: string;
        }[];
        dataList.forEach(a =>
          listDataList.push({ key: a.title, name: a.title })
        );
        return listDataList;
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
}
